import * as actionTypes from "./actionTypes";
import * as types from "./types";



// Extractor List actions

export const fetchInsituExtractorListReq = (params: types.IInsituExtractorListParams): types.FetchInsituExtractorListReq => ({
    type: actionTypes.FETCH_INSITU_EXTRACTOR_LIST_REQUEST,
    params,
});

export const fetchExtractorListSuccess = (
    payload: types.FetchInsituExtractorListSuccessPayload
): types.FetchInsituExtractorListSuccess => ({
    type: actionTypes.FETCH_INSITU_EXTRACTOR_LIST_SUCCESS,
    payload,
});

export const fetchInsituExtractorListFailure = (
    payload: types.FetchInsituExtractorListFailurePayload
): types.FetchInsituExtractorListFailure => ({
    type: actionTypes.FETCH_INSITU_EXTRACTOR_LIST_FAILURE,
    payload,
});

//Insitu Extractor Details
export const fetchInsituExtractorDetailsReq = (params: string): types.FetchInsituExtractorDetailsReq => ({
    type: actionTypes.FETCH_INSITU_EXTRACTOR_DETAILS_REQUEST,
    params,
});

export const fetchInsituExtractorDetailsSuccess = (
    payload: types.FetchInsituExtractorDetailsSuccessPayload
): types.FetchInsituExtractorDetailsSuccess => ({
    type: actionTypes.FETCH_INSITU_EXTRACTOR_DETAILS_SUCCESS,
    payload,
});

export const fetchInsituExtractorDetailsFailure = (
    payload: types.FetchInsituExtractorListFailurePayload
): types.FetchInsituExtractorListFailure => ({
    type: actionTypes.FETCH_INSITU_EXTRACTOR_LIST_FAILURE,
    payload,
});

//post insituExtractor

export const postInsituExtractorRequest = (payload: types.IPostInsituExtractorRequest): types.PostInsituExtractorRequest => ({
    type: actionTypes.POST_INSITU_EXTRACTOR_REQUEST,
    payload
});

export const postInsituExtractorSuccess = (payload: types.IPostInsituExtractorSuccessPayload): types.PostInsituExtractorSuccess => ({
    type: actionTypes.POST_INSITU_EXTRACTOR_SUCCESS,
    payload
});

export const postInsituExtractorFailure = (payload: types.IPostInsituExtractorFailurePayload): types.PostInsituExtractorFailure => ({
    type: actionTypes.POST_INSITU_EXTRACTOR_FAILURE,
    payload
});

export const postInsituExtractorReset = (
): types.PostInsituExtractorReset => ({
    type: actionTypes.POST_INSITU_EXTRACTOR_RESET,
});

//put
export const putInsituExtractorRequest = (insituId: string, payload: types.IInsituExtractorPutReq): types.PutInsituExtractorRequest => ({
    type: actionTypes.PUT_INSITU_EXTRACTOR_REQUEST,
    insituId: insituId,
    payload
});
export const putInsituExtractorFailure = (payload: types.IPutInsituExtractorFailurePayload): types.PutInsituExtractorFailure => ({
    type: actionTypes.PUT_INSITU_EXTRACTOR_FAILURE,
    payload
});

export const putInsituExtractorSuccess = (
    payload: types.IPutInsituExtractorSuccessPayload
): types.PutInsituExtractorSuccess => ({
    type: actionTypes.PUT_INSITU_EXTRACTOR_SUCCESS,
    payload,
});

export const putInsituExtractorReset = (
): types.PutInsituExtractorReset => ({
    type: actionTypes.PUT_INSITU_EXTRACTOR_RESET,
});

// DELETE Extractor

export const deleteInsituExtractorReq = (
    payload: string
): types.DeleteInsituExtractorRequest => ({
    type: actionTypes.DELETE_INSITU_EXTRACTOR_REQUEST,
    payload,
});
//DELETE
export const deleteInsituExtractorSuccess = (
    payload: types.IDeleteInsituExtractorSuccessPayload
): types.DeleteInsituExtractorSuccess => ({
    type: actionTypes.DELETE_INSITU_EXTRACTOR_SUCCESS,
    payload,
});

export const deleteInsituExtractorFailure = (
    payload: types.IDeleteInsituExtractorFailurePayload
): types.DeleteInsituExtractorFailure => ({
    type: actionTypes.DELETE_INSITU_EXTRACTOR_FAILURE,
    payload,
});